import { render } from "./index.vue?vue&type=template&id=2c8ec2c5"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/atoms/summary-item-header/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c8ec2c5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c8ec2c5', __exports__)) {
    api.reload('2c8ec2c5', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2c8ec2c5", () => {
    api.rerender('2c8ec2c5', render)
  })

}


export default __exports__